import { getData, postData, putData } from "../apiClient";


const API_URL = "website-contact-requests";
const ItemName = "Website Contact Request";

// ✅ Get all
export const getWebsiteContactRequests = async ({ page = 1, limit = 10, search = "" }) => {
  try {
    const params = new URLSearchParams({
      page,
      limit,
      ...(search && { search }),
    });

    const result = await getData(`/${API_URL}/?${params}`);

    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error(`Get ${ItemName} API error:`, error.message);
    return {
      success: false,
      ...error,
    };
  }
};

